import styled, { css } from 'styled-components';

export const OptionStyled = styled.option`
  ${({ theme }) => css`
    color: ${theme.colors.black2};
    font-size: ${theme.fontSize.px14};
  `}
`;
